import React from "react"

const Container: ({ children, style }: { children: React.ReactNode; style?: object }) => JSX.Element = ({ children , style }) => (
  <div className="container mx-auto max-w-none xxxl:max-w-screen-xxxl px-6 md:px-16" style={style}>{children}</div>
)

export default Container
